<template>
  <div :class="'roi_calculator_form_wrap step_0' + form_data.step">
    <Header
      :title="title"
      :form_data="form_data"
      :changeGoal="changeGoal"
      :changeStep="changeStep"
      msg="Welcome to Your Vue.js App"
    />
    <RoiCalculator
      :updateFormData="updateFormData"
      :updateFormErrors="updateFormErrors"
      :changeStep="changeStep"
      v-if="form_data.step > 1"
      :title="title"
      :form_data="form_data"
      msg="Welcome to Your Vue.js App"
    />
    <Results
      :updateFormData="updateFormData"
      v-if="form_data.step == 3"
      :title="title"
      :form_data="form_data"
      msg="Welcome to Your Vue.js App"
    />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import RoiCalculator from "./components/RoiCalculator.vue";
import Results from "./components/Results.vue";

export default {
  name: "App",
  components: {
    Header,
    RoiCalculator,
    Results
  },
  data() {
    return {
      title: "Please select the <br />relevant goal from the list below",
      form_data: {
        selected_goal: 0,
        step: 1,
        field_values: {},
        errors: false,
        fields: [
          {
            type: "title",
            label: "Basic Information",
            id: "basic_information"
          },
          {
            type: "slider",
            label: "Number of customers",
            id: "no_of_customers",
            value: 500,
            min_value: 0,
            max_value: 10000,
            choices: []
          },
          {
            type: "slider",
            label: "Your annual growth ($) ",
            id: "annual_revenue",
            value: 3000000,

            min_value: 0,
            max_value: 10000000,
            choices: [],
            class:"annual-growth"
          },
          {
            type: "slider",
            label: "Number of CSMs",
            id: "no_of_cms",
            value: 10,
            min_value: 0,
            max_value: 50,
            choices: []
          },
          {
            type: "slider",
            label: "Expected account growth in next period",
            id: "anticipated_account_growth_in_next_period",
            value: 30,
            min_value: 0,
            max_value: 200,
            choices: [],
            prefix: "%",
            class:"expected-growth"
          },
          {
            type: "title",
            label: "Team Productivity",
            id: "team_productivity"
          },
          {
            type: "radio",
            label:
              "How often do your CSMs meet their revenue and CS goals?",
            id: "to_what_extend_do_your_cms_meet_their",
            value: null,
            choices: [
              { label: "Always", value: 100 },
              { label: "Often", value: 66 },
              { label: "Sometimes", value: 33 },
              { label: "Never", value: 0 }
            ]
          },
          {
            type: "radio",
            label:
              "Do you find it easy to scale your teams according to your CS strategy?",
            id: "how_easy_is_it_fo_you_to_scale_teams",
            value: null,
            choices: [
              { label: "Always", value: 100 },
              { label: "Often", value: 66 },
              { label: "Sometimes", value: 33 },
              { label: "Never", value: 0 }
            ]
          },
          {
            type: "radio",
            label:
              "How many operational tools/data sources do your CSMs use for operations?",
            id: "how_many_opeational_tools",
            value: null,
            choices: [
              { label: ">10", value: 0 },
              { label: "6-10", value: 33 },
              { label: "3-5", value: 66 },
              { label: "1-2", value: 100 }
            ]
          },
          {
            type: "title",
            label: "Operational Efficiency",
            id: "operational_efficiency"
          },
          {
            type: "radio",
            label:
              "How well are your current CS processes mapped to a platform?",
            id: "to_what_extend_are_your_current_cs_processes",
            value: null,
            choices: [
              { label: "Very Good", value: 100 },
              { label: "Good", value: 66 },
              { label: "Poor", value: 33 },
              { label: "Not at all", value: 0 }
            ]
          },
          {
            type: "radio",
            label:
              "How automated are your CS workflows?",
            id: "to_what_extend_is_automation_employed",
            value: null,
            choices: [
              { label: "Very Good", value: 100 },
              { label: "Good", value: 66 },
              { label: "Poor", value: 33 },
              { label: "Not at all", value: 0 }
            ]
          },
          {
            type: "radio",
            label:
              "How well does your current system flag risks and opportunities?",
            id: "does_your_current_system_flag",
            value: null,
            choices: [
              { label: "Very Good", value: 100 },
              { label: "Good", value: 66 },
              { label: "Poor", value: 33 },
              { label: "Not at all", value: 0 }
            ]
          },
          {
            type: "radio",
            label:
              "How is your ability to customize processes to meet the needs of different customer segments while maintaining quality?",
            id: "are_your_processes_adaptable",
            value: null,
            choices: [
              { label: "Very Good", value: 100 },
              { label: "Good", value: 66 },
              { label: "Poor", value: 33 },
              { label: "Not at all", value: 0 }
            ]
          },
          {
            type: "title",
            label: "Customer Experience",
            id: "customer_experience"
          },
          {
            type: "radio",
            label:
              "How well is your CS Team engaging with key customer contacts?",
            id: "are_your_cms_sufficiently",
            value: null,
            choices: [
              { label: "Very Good", value: 100 },
              { label: "Good", value: 66 },
              { label: "Poor", value: 33 },
              { label: "Not at all", value: 0 }
            ]
          },
          {
            type: "slider",
            label: "What % of your desired audience do you engage with?",
            id: "what_percentage_of_your_desired_audience",
            value: 50,
            prefix: "%",
            class:"what-percent"
          },
          {
            type: "radio",
            label:
              "How is your ability to personalize engagement with your customers?",
            id: "are_you_able_to_personalize",
            value: null,
            choices: [
              { label: "Very Good", value: 100 },
              { label: "Good", value: 66 },
              { label: "Poor", value: 33 },
              { label: "Not at all", value: 0 }
            ]
          },
          {
            type: "radio",
            label:
              "How is your current system’s ability to intelligently optimize and enhance your customer experience?",
            id: "does_your_current_system_process",
            value: null,
            choices: [
              { label: "Very Good", value: 100 },
              { label: "Good", value: 66 },
              { label: "Poor", value: 33 },
              { label: "Not at all", value: 0 }
            ]
          },
          {
            type: "title",
            label: "Value Realization",
            id: "value_realization"
          },
          {
            type: "radio",
            label:
              "Are your CSMs able to demonstrate First Value to their customers within a reasonable time frame?",
            id: "are_your_csms_able_to_demonstrate",
            value: null,
            choices: [
              { label: "Always", value: 100 },
              { label: "Often", value: 66 },
              { label: "Sometimes", value: 33 },
              { label: "Never", value: 0 }
            ]
          },
          {
            type: "radio",
            label:
              "How is your ability to automate CS plans based on a pattern of value milestones?",
            id: "do_you_have_the_ability_to_drive",
            value: null,
            choices: [
              { label: "Very Good", value: 100 },
              { label: "Good", value: 66 },
              { label: "Poor", value: 33 },
              { label: "Not at all", value: 0 }
            ]
          }
        ]
      }
    };
  },
  methods: {
    updateFormData(fields) {
      let th = this;
      let new_values = {};
      let new_errors = false;
      fields.forEach((element, index) => {
        if (element["type"] != "title") {
          new_values[element["id"]] = element["value"];
        }

        if (th.form_data.selected_goal == 1) {
          if (index < 14) {
            if (element["type"] == "radio") {
              if (element["value"] == null) {
                new_errors = true;
              }
            }
          }
        } else if (th.form_data.selected_goal == 2) {
          if (index < 14) {
            if (element["type"] == "radio") {
              if (element["value"] == null) {
                new_errors = true;
              }
            }
          }
        } else {
          if (element["type"] == "radio") {
            if (element["value"] == null) {
              new_errors = true;
            }
          }
        }
      });

      this.form_data.errors = new_errors;
      this.form_data.field_values = new_values;

      // hide final step
      this.changeStep(2);
      return [fields, ...this.form_data.fields];
    },
    changeGoal(goal) {
      this.form_data.selected_goal = goal;
      this.form_data.step = 2;
    },
    preserveFormValues(){
    this.form_data.fields.forEach((o)=>{
      if(typeof(this.form_data.field_values[o.id]) != "undefined"){
        o.value = this.form_data.field_values[o.id];
      }
    });
    },
    changeStep(step) {

      this.preserveFormValues();
      
      if (step == 3) {
        this.form_data.field_values.selected_goal = this.form_data.selected_goal;
        fetch("https://www.smartkarrot.com/?roi_api=true", {
          method: "POST",
          body: JSON.stringify({ form_data: this.form_data.field_values })
        });
      }
      this.form_data.step = step;
    }
  }
};
</script>

<style>
#app {
  font-family: "Roboto Slab", serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
